import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useMeta } from "@/hooks/useMeta";
import { PageHeader, FilterCard, Field, SimpleSelect, EmptyState } from "@/components/common";
import { fmtPct, statusBg } from "@/lib/helpers";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { ClipboardList } from "lucide-react";

export default function Ringkasan() {
  const { indikators, tahuns } = useMeta();
  const [indikator, setIndikator] = useState("");
  const [tahun, setTahun] = useState("");
  const [data, setData] = useState(null);

  useEffect(() => { if (!indikator && indikators.length) setIndikator(indikators[0].kode); }, [indikators]);
  useEffect(() => { if (!tahun && tahuns.length) setTahun(String(tahuns[0])); }, [tahuns]);
  useEffect(() => {
    if (!indikator || !tahun) return;
    api.get(`/ringkasan/keseluruhan?indikator=${encodeURIComponent(indikator)}&tahun=${tahun}`).then((r) => setData(r.data));
  }, [indikator, tahun]);

  const rows = (data?.data || []).filter((d) => d.ada_data);

  return (
    <div data-testid="ringkasan-page">
      <PageHeader icon={ClipboardList} title="Ringkasan Keseluruhan per Bulan" subtitle="Satu angka capaian gabungan seluruh poliklinik per bulan = total N / total D semua poliklinik." />

      <FilterCard>
        <Field label="Indikator">
          <SimpleSelect testId="rk-indikator-select" value={indikator} onChange={setIndikator}
            options={indikators.map((i) => ({ label: i.kode, value: i.kode }))} className="w-[220px]" />
        </Field>
        <Field label="Tahun">
          <SimpleSelect testId="rk-tahun-select" value={tahun} onChange={setTahun}
            options={tahuns.map((t) => ({ label: String(t), value: t }))} className="w-[120px]" />
        </Field>
      </FilterCard>

      <Card className="border-slate-200 shadow-sm">
        <CardHeader><CardTitle className="text-lg">Capaian Gabungan {indikator} — {tahun}</CardTitle></CardHeader>
        <CardContent>
          {rows.length === 0 ? (
            <EmptyState icon={ClipboardList} title="Belum ada data" desc="Upload data bulanan untuk melihat ringkasan." />
          ) : (
            <div className="overflow-x-auto rounded-lg border border-slate-200">
              <Table>
                <TableHeader>
                  <TableRow className="bg-slate-50">
                    <TableHead>Bulan</TableHead>
                    <TableHead className="text-right">Total N</TableHead>
                    <TableHead className="text-right">Total D</TableHead>
                    <TableHead className="text-right">Target</TableHead>
                    <TableHead className="text-right">Capaian Gabungan</TableHead>
                  </TableRow>
                </TableHeader>
                <TableBody>
                  {rows.map((d) => (
                    <TableRow key={d.bulan} data-testid={`ringkasan-row-${d.bulan}`}>
                      <TableCell className="font-medium">{d.bulan_nama}</TableCell>
                      <TableCell className="text-right tabular-nums">{d.total_n}</TableCell>
                      <TableCell className="text-right tabular-nums">{d.total_d}</TableCell>
                      <TableCell className="text-right tabular-nums text-slate-500">{fmtPct(d.target)}</TableCell>
                      <TableCell className="text-right">
                        <span className={`inline-block px-2.5 py-1 rounded-md text-sm font-bold tabular-nums ${statusBg(d.capaian, d.target) || "bg-slate-100 text-slate-600"}`}>{fmtPct(d.capaian)}</span>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </div>
          )}
        </CardContent>
      </Card>
    </div>
  );
}
